import enUS from "./en-US";

const thTH = {
  ...enUS,
  common: {
    ...enUS.common,
    langShortZh: "中",
    langShortEn: "EN",
    langShortTh: "TH",
    langZh: "中文",
    langEn: "English",
    langTh: "ไทย",
    searchPlaceholder: "ค้นหาสถานที่ท่องเที่ยว คู่มือ และข่าวสาร...",
    loading: "กำลังโหลด...",
    loadingContent: "กำลังโหลดเนื้อหา...",
    expandMore: "แสดงเพิ่มเติม",
    collapse: "ย่อ",
    print: "พิมพ์",
    go: "ไป",
    noContent: "ไม่มีเนื้อหา",
    comingSoon: "เร็ว ๆ นี้",
    author: "ผู้เขียน: ",
    publishTime: "เผยแพร่เมื่อ: ",
    phone: "โทรศัพท์: ",
    address: "ที่อยู่: ",
    backHome: "กลับหน้าแรก",
    pageNotFound: "ไม่พบหน้า",
    pageNotFoundDesc: "ไม่พบหน้าที่คุณต้องการหรือถูกย้ายแล้ว",
    underDevelopment: "ฟังก์ชันนี้กำลังพัฒนา",
    cmsConfigHint:
      "กำลังกำหนดค่าเนื้อหา (โปรดติดแท็ก '{tag}' ให้บทความหรือสื่อใน CMS)",
    noMediaContent: "ไม่มีสื่อ",
    contentConfiguring: "กำลังกำหนดค่าเนื้อหา โปรดรอสักครู่",
    pageNumber: "หน้า",
    defaultPublisher: "สำนักงานบริหาร Dagu Glacier",
  },
  nav: {
    ...enUS.nav,
    "/": "หน้าหลัก",
    "/about": "เกี่ยวกับ Dagu",
    "/about/intro/views": "รายละเอียดจุดชมวิว",
    "/about/intro": "ภาพรวมพื้นที่",
    "/about/honor": "เกียรติยศ",
    "/about/geology": "ธรณีวิทยา",
    "/about/glacier-research": "วัฒนธรรมพื้นบ้าน",
    "/about/RedCulture": "วัฒนธรรมกองทัพแดง",
    "/about/ecology": "นิเวศวิทยา",
    "/about/experiment": "ห้องทดลองธารน้ำแข็ง",
    "/panorama": "พาโนรามา",
    "/panorama/live": "ไลฟ์สด",
    "/panorama/videos": "วิดีโอ",
    "/panorama/shorts": "คลิปสั้น",
    "/panorama/gallery": "แกลเลอรี",
    "/panorama/dagu-er": "ช่วงเวลาของ Dagu",
    "/service": "บริการนักท่องเที่ยว",
    "https://www.abatour.com/": "จองบัตร",
    "/service/food": "อาหาร",
    "/service/food/:id": "รายละเอียดอาหาร",
    "/service/traffic": "การเดินทาง",
    "/service/route": "เส้นทางแนะนำ",
    "/service/stay": "ที่พัก",
    "/service/stay/:id": "รายละเอียดที่พัก",
    "/service/specialty": "ของฝาก",
    "/service/play": "คู่มือเที่ยว",
    "/service/entertainment": "กิจกรรมพักผ่อน",
    "/service/entertainment/:id": "รายละเอียดกิจกรรม",
    "/service/map": "แผนที่",
    "/service/tips": "ข้อควรรู้",
    "/service/products": "แพ็กเกจท่องเที่ยว",
    "/service/products/sunshine-snow": "ทัวร์หิมะกลางแสงแดด",
    "/service/products/ice-summer": "ทัวร์คลายร้อนกับน้ำแข็ง",
    "/service/products/snow-mountain-forest": "ทัวร์ภูเขาหิมะและป่าสีสัน",
    "/service/products/glacier-science": "ทัวร์วิทยาศาสตร์ธารน้ำแข็ง",
    "/service/products/red-culture": "ทัวร์วัฒนธรรมสีแดง",
    "/service/questionnaire": "แบบสอบถาม",
    "/service/complaints": "ร้องเรียน",
    "/gov": "ศูนย์ราชการ",
    "/gov/politics": "ข่าวพรรคและการเมือง",
    "/gov/news": "ข่าวพื้นที่ท่องเที่ยว",
    "/gov/dynamic": "ความเคลื่อนไหวด้านวัฒนธรรมและการท่องเที่ยว",
    "/gov/employee": "บุคลากรดีเด่น",
    "/gov/media": "สื่อมวลชน",
    "/gov/notices": "ประกาศทางการ",
    "/gov/procurement": "ข้อมูลจัดซื้อจัดจ้าง",
    "/gov/mailbox": "กล่องจดหมายผู้บริหาร",
    "/gov/press": "ข่าวประชาสัมพันธ์",
    "/marketing": "การตลาด",
    "/marketing/brand": "กิจกรรมแบรนด์",
    "/marketing/promotion": "ประชาสัมพันธ์ตลาด",
    "/marketing/cross": "ความร่วมมือข้ามวงการ",
    "/marketing/mediaCare": "สื่อจับตา",
    "/marketing/campaigns": "แคมเปญการตลาด",
    "/marketing/party": "กิจกรรมพรรค",
    "/marketing/units": "กิจกรรมพนักงาน",
    "/study": "ทัศนศึกษา",
    "/news": "ศูนย์ข่าว",
    "/news/:id": "รายละเอียดข่าว",
  },
  home: {
    ...enUS.home,
    heroTitle: "Dagu Glacier",
    heroSub: "เหนือเมฆา · ดินแดนหิมะอันบริสุทธิ์",
    latestNews: "ข่าวล่าสุด",
    photoStory: "เรื่องเล่าผ่านภาพ",
    ticketing: "จองบัตร",
    live: "ไลฟ์สด",
    ugc: "ช่วงเวลาของ Dagu",
    glacierCover: "ผ้าคลุมธารน้ำแข็ง",
    glacierExperiment: "ห้องทดลองธารน้ำแข็ง",
    activities: "กิจกรรม",
    notices: "ประกาศทางการ",
    research: "งานวิจัย",
    emptyNotice: "ไม่มีประกาศ",
    viewDetail: "ดูรายละเอียด",
    ticketBooking: "ช่องทางจองบัตรทางการ",
    heroAltitude: "ระดับความสูง",
    heroOpenTime: "เวลาเปิดทำการ",
    heroBooking: "จองออนไลน์",
    heroConsult: "สายด่วน",
    quickFood: "อาหาร",
    quickStay: "ที่พัก",
    quickRoute: "เส้นทาง",
    quickGuide: "คู่มือ",
    quickSpecialty: "ของฝาก",
    quickLeisure: "พักผ่อน",
    mobileLatestNews: "ข่าวล่าสุด",
    quickPhotoStory: "เรื่องเล่าผ่านภาพ",
    quickLive: "ไลฟ์สด",
    quickTraffic: "เส้นทางเดินทาง",
    quickTips: "ข้อควรรู้ก่อนชม",
    quickMap: "แผนที่นำเที่ยว",
    quickProducts: "เส้นทางแนะนำ",
    quickPlay: "คู่มือ",
    quickEntertainment: "กิจกรรม",
    weatherGuide: "สภาพอากาศ",
    daguErTitle: "ช่วงเวลาของ Dagu",
    daguErSubtitle:
      "บันทึกทุกช่วงเวลา ถ่ายทอด Dagu ผ่านภาพถ่ายจากมุมมองที่แตกต่าง",
    glacierCoverTitle: "ผ้าคลุมธารน้ำแข็ง",
    glacierCoverText:
      "ในปี 2020 สถาบันบัณฑิตวิทยาศาสตร์จีนได้ทดลอง 'คลุมผ้าธารน้ำแข็ง' ที่ Dagu Glacier เป็นครั้งแรกในจีน เพื่อชะลอการละลายของธารน้ำแข็งด้วยวัสดุสะท้อนความร้อน",
    glacierExperimentTitle: "ห้องทดลองธารน้ำแข็ง",
    glacierExperimentText:
      "Dagu Glacier มีทรัพยากรการเรียนรู้นอกห้องเรียนที่หลากหลาย ครอบคลุมเส้นทางศึกษา 5 รูปแบบ ศูนย์กลาง 1 แห่ง และจุดเรียนรู้ 8 จุด",
    activitiesDesc:
      "เพื่อขยายอิทธิพลของแบรนด์พื้นที่ท่องเที่ยว Dagu Glacier ได้ดำเนินกิจกรรมการตลาดหลากหลายรูปแบบ ทั้งออนไลน์และออฟไลน์ เพื่อเพิ่มการรับรู้และความน่าสนใจ",
    onlineBooking: "จองออนไลน์",
    officialChannel: "ช่องทางทางการ",
    consultPhone: "สายด่วน",
  },
  ticket: {
    ...enUS.ticket,
    todayTicketRemaining: "จำหน่ายบัตรวันนี้",
    todayCablewayRemaining: "จำหน่ายกระเช้าวันนี้",
    highest: "สูงสุด",
    lowest: "ต่ำสุด",
    traffic: "การเดินทาง",
    tips: "ข้อควรรู้",
    map: "แผนที่",
    products: "เส้นทางแนะนำ",
    openingTime: "เวลาเปิดทำการ",
    weatherGuide: "สภาพอากาศ",
  },
  photoStory: {
    ...enUS.photoStory,
    empty: 'กำหนดสไลด์ใน CMS สำหรับ "เรื่องเล่าผ่านภาพ"',
  },
  footer: {
    ...enUS.footer,
    friends: "ลิงก์แนะนำ",
    surveys: "แบบสอบถาม",
    qrNeed: "ต้องมี QR",
    qrScan: "สแกน",
    qrSub1: "สแกนเพื่อเข้าสู่เว็บไซต์มือถือ",
    qrSub2: "Dagu Glacier",
    consult: "ข้อมูลท่องเที่ยว",
    complaint: "ร้องเรียนการท่องเที่ยว",
    reportPhone: "สายด่วนแจ้งข้อมูลผิดกฎหมาย",
    reportEmail: "อีเมลรับแจ้ง",
    reportCenterCn: "ศูนย์รับแจ้งอินเทอร์เน็ตจีน",
    reportCenterSc: "ศูนย์รับแจ้งอินเทอร์เน็ตเสฉวน",
    channelVoiceGuide: "คู่มือเสียง",
    qrMobileSite: "QR เว็บไซต์มือถือ Dagu Glacier",
    surveyNationalStandard: "แบบฟอร์มรับฟังความคิดเห็นนักท่องเที่ยวมาตรฐาน",
    surveySatisfaction: "แบบสำรวจความพึงพอใจนักท่องเที่ยวมาตรฐาน",
    surveyNationalStandardQuery: "แบบฟอร์มรับฟังความคิดเห็นนักท่องเที่ยวมาตรฐาน",
    surveySatisfactionQuery: "แบบสำรวจความพึงพอใจนักท่องเที่ยวมาตรฐาน",
  },
  gov: {
    tabs: {
      all: "ทั้งหมด",
      politics: "พรรคและการเมือง",
      news: "ข่าวพื้นที่",
      dynamic: "ความเคลื่อนไหววัฒนธรรมและการท่องเที่ยว",
      employee: "บุคลากรดีเด่น",
      media: "สื่อมวลชน",
      notices: "ประกาศ",
      procurement: "จัดซื้อจัดจ้าง",
      mailbox: "กล่องจดหมาย",
      press: "ข่าวประชาสัมพันธ์",
    },
    jump: "ไป",
  },
  gallery: {
    ...enUS.gallery,
    loadMore: "โหลดเพิ่ม",
    prevImage: "ก่อนหน้า",
    nextImage: "ถัดไป",
    noImage: "ไม่มีรูปภาพ",
    untitled: "ภาพไม่มีชื่อ",
  },
  intro: {
    ...enUS.intro,
    title: "ภาพรวมพื้นที่ท่องเที่ยว",
    moreContent: "ดูเพิ่มเติม",
  },
  header: {
    ...enUS.header,
    logoAlt: "Dagu Glacier",
    searchAlt: "ค้นหา",
    dropdownAlt: "เมนูดรอปดาวน์",
  },
  video: {
    ...enUS.video,
    noPlayableUrl: "ไม่มีลิงก์สำหรับเล่น",
    unnamedVideo: "วิดีโอไม่มีชื่อ",
  },
  news: {
    ...enUS.news,
    externalLinkNotice: "เนื้อหานี้เป็นลิงก์ภายนอก:",
    noExternalLink: "ยังไม่ได้ตั้งค่าลิงก์ภายนอก",
    relatedTitle: "แนะนำเพิ่มเติม",
  },
  geology: {
    ...enUS.geology,
    comingSoon: "เตรียมพบเนื้อหาธรณีวิทยาเพิ่มเติม",
    title: "ธรณีวิทยา",
    viewMore: "ดูเพิ่มเติม",
  },
  ecology: {
    ...enUS.ecology,
    title: "นิเวศวิทยา",
    geologySection: "ภาคธรณีวิทยา",
    biologySection: "ภาคชีววิทยา",
    animalOverview: "ภาพรวมสัตว์ใน Dagu Glacier",
    plantOverview: "ภาพรวมพืชใน Dagu Glacier",
  },
  live: {
    ...enUS.live,
    title: "ไลฟ์สด",
  },
  tips: {
    ...enUS.tips,
    noContent: "ไม่มีข้อมูลข้อควรรู้สำหรับนักท่องเที่ยว",
    comingSoon: "ข้อควรรู้เพิ่มเติมกำลังจะมา",
  },
  traffic: {
    ...enUS.traffic,
    noContent: "ไม่มีข้อมูลการเดินทาง",
    comingSoon: "ข้อมูลการเดินทางเพิ่มเติมกำลังจะมา",
  },
  service: {
    ...enUS.service,
    complaintPhone: "สายด่วนร้องเรียน",
  },
  homeData: {
    ...enUS.homeData,
    weatherLocation: "เขตปกครองตนเองอาปาทิเบตและเชียง",
    weatherCondition: "แดดออก",
    researchFallback1:
      "บทความ: การเปลี่ยนแปลงสภาพภูมิอากาศ ทรัพยากรธรรมชาติ และการพัฒนาอย่างยั่งยืนใน Dagu Glacier",
    researchFallback2:
      "บทความ: การคุ้มครองโซนมรดกธรณีวิทยาใน Dagu Glacier Geopark",
    researchFallback3:
      "บทความ: ทรัพยากรและคุณค่าทางธรณีวิทยาของ Dagu Glacier Geopark",
    researchFallback4:
      "หนังสือ: ธารน้ำแข็งภูเขาและการท่องเที่ยวอย่างยั่งยืน",
    researchFallback5: "Dagu Glacier ดำเนินโครงการติดตามธารน้ำแข็งอย่างต่อเนื่อง",
  },
  serviceHomePage: {
    ...enUS.serviceHomePage,
    ticketBooking: "จองบัตร",
    officialNotices: "ประกาศทางการ",
    openingTime: "เวลาเปิดทำการ",
    peakSeason: "ฤดูท่องเที่ยว",
    offSeason: "นอกฤดูท่องเที่ยว",
    scenicOpenTime: "เวลาเปิดพื้นที่: ",
    ticketPrice: "บัตรเข้า",
    cablewayPrice: "กระเช้า",
    sightseeingCarPrice: "รถชมวิว",
    visitorTips: "ข้อควรรู้",
    trafficGuide: "การเดินทาง",
    scenicMap: "แผนที่พื้นที่",
    tourismProducts: "แพ็กเกจท่องเที่ยว",
    businessRecommendation: "แนะนำบริการ",
    questionnaire: "แบบสอบถาม",
    complaint: "ร้องเรียน",
    consultPhone: "สายด่วน",
    viewMap: "ดูแผนที่ขนาดใหญ่",
    scanQRCode: "สแกน QR เพื่อกรอกแบบสอบถาม",
    configurableImage: "รูปภาพที่ตั้งค่าได้",
    mapPreviewTitle: "ตัวอย่างแผนที่พื้นที่",
    close: "ปิด",
    quickOpenTime: "เวลาเปิด",
    quickBooking: "จองบัตร",
    quickAltitude: "ระดับความสูง",
    quickTraffic: "การเดินทาง",
    quickMap: "แผนที่พื้นที่",
    quickTips: "ข้อควรรู้",
    highwayRoute: "ทางหลวง",
    railRoute: "รถไฟความเร็วสูง",
    flightRoute: "เครื่องบิน",
    consultPhoneLabel: "สายด่วน",
    complaintPhoneLabel: "ร้องเรียน",
    tipsHalfTitle: "สิทธิ์บัตรครึ่งราคา",
    tipsFreeTitle: "สิทธิ์บัตรฟรี",
  },
  campaignsPage: {
    ...enUS.campaignsPage,
    title: "แคมเปญการตลาด",
    all: "ทั้งหมด",
    loadMore: "โหลดเพิ่ม",
  },
  govPage: {
    ...enUS.govPage,
    externalLinkNotice: "เนื้อหานี้เป็นลิงก์ภายนอก:",
    noExternalLink: "ยังไม่ได้ตั้งค่าลิงก์ภายนอก",
    loadingContent: "กำลังโหลดเนื้อหา...",
    noContent: "ไม่มีเนื้อหา",
    externalLink: "ลิงก์ภายนอก",
  },
  govPortal: {
    ...enUS.govPortal,
    pageTitle: "ศูนย์ราชการ",
    leadershipTeam: "{'|'} ทีมผู้บริหาร",
    politics: "ข่าวพรรคและการเมือง",
    scenicNews: "ข่าวพื้นที่ท่องเที่ยว",
    scenicNewsPrefix: "{'|'} ข่าวพื้นที่ท่องเที่ยว",
    mediaFocus: "สื่อมวลชน",
    officialNotices: "ประกาศทางการ",
    officialNoticesPrefix: "{'|'} ประกาศทางการ",
    procurement: "ข้อมูลจัดซื้อจัดจ้าง",
    procurementPrefix: "{'|'} ข้อมูลจัดซื้อจัดจ้าง",
    mailbox: "กล่องจดหมายผู้บริหาร",
    viewMore: "ดูเพิ่มเติม",
    configurableImage: "รูปภาพที่ตั้งค่าได้",
    defaultName: "ชื่อ",
    defaultRole: "ตำแหน่ง",
    defaultAddress: "ที่อยู่ติดต่อ",
    defaultText: "ข้อความตัวอย่างสำหรับการแสดงผลและทดสอบหน้า",
    mockContentPrefix: "เนื้อหาตัวอย่างสำหรับการทดสอบหน้า (",
    mockContentSuffix: ")",
    sample: "ตัวอย่าง",
  },
  marketing: {
    ...enUS.marketing,
    brandTitle: "กิจกรรมแบรนด์",
    brandSubtitleDesktop:
      "สร้างภาพจำ สร้างความคาดหวัง ด้วยธีมที่ชัดเจนและประสบการณ์ที่น่าจดจำ",
    brandSubtitleMobile:
      "สร้างภาพจำ สร้างความคาดหวัง<br>ด้วยธีมที่ชัดเจนและประสบการณ์ที่น่าจดจำ",
    promotionTitle: "ประชาสัมพันธ์ตลาด",
    crossTitle: "ความร่วมมือข้ามวงการ",
    mediaCareTitle: "สื่อจับตา",
    campaignsTitle: "แคมเปญการตลาด",
    partyTitle: "กิจกรรมพรรค",
    unitsTitle: "กิจกรรมพนักงาน",
    viewMore: "ดูเพิ่มเติม",
    more: "เพิ่มเติม",
    morePlus: "เพิ่มเติม+",
    clickForDetails: "คลิกเพื่อดูรายละเอียด",
    configurableTitle: "หัวข้อที่ตั้งค่าได้",
    configurableImage: "รูปภาพที่ตั้งค่าได้",
  },
  backToTop: {
    ...enUS.backToTop,
    label: "กลับด้านบน",
  },
  breadcrumb: {
    ...enUS.breadcrumb,
    currentPosition: "ตำแหน่งปัจจุบัน: ",
    home: "หน้าหลัก",
  },
  pages: {
    ...enUS.pages,
    immersiveCloudTour: {
      ...enUS.pages.immersiveCloudTour,
      liveStream: "ไลฟ์สด",
      videos: "วิดีโอ",
      shortsCollection: "คลิปสั้น",
      more: "เพิ่มเติม",
      gallery: "แกลเลอรี",
      viewMore: "ดูเพิ่มเติม",
      daguEr: "ช่วงเวลาของ Dagu",
      daguErDesc:
        "บันทึกช่วงเวลา ถ่ายทอด Dagu ผ่านภาพถ่ายจากมุมมองที่แตกต่าง",
      noPlayableUrl: "ไม่มีลิงก์สำหรับเล่น",
      noImage: "ไม่มีรูปภาพ",
      unnamedVideo: "วิดีโอไม่มีชื่อ",
      unnamedWork: "ผลงานไม่มีชื่อ",
    },
    panoramaGallery: {
      ...enUS.pages.panoramaGallery,
      title: "แกลเลอรี",
      spring: {
        ...enUS.pages.panoramaGallery.spring,
        seasonTitle: "แกลเลอรีฤดูใบไม้ผลิ",
        title: "ฤดูใบไม้ผลิ · ดอกไม้และหิมะ",
      },
      summer: {
        ...enUS.pages.panoramaGallery.summer,
        seasonTitle: "แกลเลอรีฤดูร้อน",
        title: "ฤดูร้อน · พักผ่อนคลายร้อน",
      },
      autumn: {
        ...enUS.pages.panoramaGallery.autumn,
        seasonTitle: "แกลเลอรีฤดูใบไม้ร่วง",
        title: "ฤดูใบไม้ร่วง · ป่าสีสัน",
      },
      winter: {
        ...enUS.pages.panoramaGallery.winter,
        seasonTitle: "แกลเลอรีฤดูหนาว",
        title: "ฤดูหนาว · ดินแดนน้ำแข็ง",
      },
    },
    scenicIntro: {
      ...enUS.pages.scenicIntro,
      bannerLoading: "กำลังโหลดแบนเนอร์...",
      collapse: "ย่อ",
      expand: "ขยาย",
      characteristicLandscape: "ภูมิทัศน์เด่น",
      noLandscape: "ยังไม่มีภูมิทัศน์เด่น",
      comingSoonHint: "เนื้อหาเพิ่มเติมกำลังมา",
    },
    study: {
      ...enUS.pages.study,
      heroAlt: "Dagu Glacier",
      fiveResources: "ทรัพยากรการเรียนรู้ 5 ด้าน",
      fiveTravels: "เส้นทางเรียนรู้ 5 รูปแบบ",
      studySystem: 'ระบบการเรียนรู้ "1+8+N" ของ Dagu Glacier',
      outdoorStations: "จุดเรียนรู้นอกห้องเรียน 8 จุด",
      oneCoreHub: "ศูนย์กลางการเรียนรู้ 1 แห่ง",
      centerImgAlt: "ภาพศูนย์กลาง",
      stationImgAlt: "จุดเรียนรู้",
      travelAlt: "เส้นทาง",
    },
    honors: {
      ...enUS.pages.honors,
      title: "เกียรติยศและรางวัล",
      all: "ทั้งหมด",
      yearTitle: "ประจำปี",
      noHonors: "ยังไม่มีเกียรติยศ",
      comingSoonHint: "เกียรติยศเพิ่มเติมกำลังมา",
    },
    glacierExperiment: {
      ...enUS.pages.glacierExperiment,
      title: "การทดลองธารน้ำแข็ง",
      noContent: "ไม่มีเนื้อหา",
      comingSoonHint: "เนื้อหาการทดลองธารน้ำแข็งเพิ่มเติมกำลังมา",
      pageNumber: "หน้า",
      jump: "ไป",
    },
    glacierResearch: {
      ...enUS.pages.glacierResearch,
      title: "วัฒนธรรมพื้นบ้าน",
      noContent: "ไม่มีเนื้อหา",
      comingSoonHint: "เนื้อหา{title}เพิ่มเติมกำลังมา",
      pageNumber: "หน้า",
      jump: "ไป",
    },
    productTours: {
      ...enUS.pages.productTours,
      sunshineSnow: {
        ...enUS.pages.productTours.sunshineSnow,
        title: "ทัวร์หิมะกลางแสงแดด",
        heroAria: "ทัวร์หิมะกลางแสงแดด",
        previewAria: "ไฮไลต์ทัวร์หิมะกลางแสงแดด",
        detailAria: "รายละเอียดทัวร์หิมะกลางแสงแดด",
        imageLoadFailed: "โหลดรูปภาพไม่สำเร็จ",
      },
      iceSummer: {
        ...enUS.pages.productTours.iceSummer,
        title: "ทัวร์คลายร้อนกับน้ำแข็ง",
        heroAria: "ทัวร์คลายร้อนกับน้ำแข็ง",
        detailAria: "รายละเอียดทัวร์คลายร้อนกับน้ำแข็ง",
      },
      snowMountainForest: {
        ...enUS.pages.productTours.snowMountainForest,
        title: "ทัวร์ภูเขาหิมะและป่าสีสัน",
        heroAria: "ทัวร์ภูเขาหิมะและป่าสีสัน",
        miniCardsAria: "ไฮไลต์ทัวร์ภูเขาหิมะและป่าสีสัน",
        detailAria: "รายละเอียดทัวร์ภูเขาหิมะและป่าสีสัน",
      },
      glacierScience: {
        ...enUS.pages.productTours.glacierScience,
        title: "ทัวร์วิทยาศาสตร์ธารน้ำแข็ง",
        heroAria: "ทัวร์วิทยาศาสตร์ธารน้ำแข็ง",
        pairAria: "ภาพตัวอย่างทัวร์วิทยาศาสตร์ธารน้ำแข็ง",
        sectionsAria: "หัวข้อทัวร์วิทยาศาสตร์ธารน้ำแข็ง",
        summitAria: "ยอดธารน้ำแข็ง 4860",
      },
      redCulture: {
        ...enUS.pages.productTours.redCulture,
        title: "ทัวร์วัฒนธรรมสีแดง",
        heroAria: "ทัวร์วัฒนธรรมสีแดง",
        sculptureAria: "กลุ่มประติมากรรมกองทัพแดง",
        detailAria: "รายละเอียดทัวร์วัฒนธรรมสีแดง",
      },
    },
    scenicSpotIntroductionViews: {
      ...enUS.pages.scenicSpotIntroductionViews,
      heroAlt: "ทิวทัศน์",
      defaultImageAlt: "ทิวทัศน์",
      detail: {
        ...enUS.pages.scenicSpotIntroductionViews.detail,
        title: "ทะเลสาบ Dagu",
      },
    },
  },
  newsListPage: {
    mockItems: [
      {
        title: "กิจกรรมฤดูหนาวของ Dagu Glacier เปิดแล้ว",
        summary: "ไฮไลต์กิจกรรมและคำแนะนำสำหรับผู้เยี่ยมชม",
      },
      {
        title: "อัปเดตคู่มือการเดินทาง",
        summary: "คำแนะนำสำหรับขับรถและขนส่งสาธารณะ",
      },
    ],
  },
  newsDetailPage: {
    sampleTitle: "หัวข้อข่าวตัวอย่าง",
    sampleContent:
      "<p>เนื้อหาตัวอย่างจะแสดงที่นี่หลังเผยแพร่ใน CMS</p><p>รองรับ Rich Text เช่น:</p><ul><li>รายการตัวอย่าง 1</li><li>รายการตัวอย่าง 2</li></ul>",
  },
  serviceTipsPage: {
    sampleContent:
      "<p>เนื้อหาข้อควรรู้สำหรับนักท่องเที่ยวจะแสดงที่นี่เมื่อเผยแพร่ใน CMS</p>",
  },
  serviceLeisurePage: {
    mockItems: [
      "เนื้อหาพักผ่อนตัวอย่าง",
      "ตัวอย่าง: กิจกรรมและประสบการณ์ที่แนะนำ",
    ],
  },
  panoramaLivePage: {
    defaultLocations: [
      "หาด Lovers' Beach ที่ทะเลสาบ Dagu",
      "ทะเลสาบ Jinbao",
      "Zenaco",
      "ป่าสีสันทอดยาว",
      "Mount Logos",
      "สถานีกระเช้าด้านบน",
    ],
  },
  panoramaDaguErPage: {
    mockAuthor: "FROM: ช่างภาพ Dagu {index}",
  },
} as typeof enUS;

export default thTH;
